<template>
  <div class="resource">
    <div class="resource-banner">
      <img :src="banner" alt="专题banner" />
    </div>
    <div class="resource-content">
      <ue-tabs :tabs="tabs" @loadPost="change"></ue-tabs>
      <div class="resource-enterprise" v-if="index === '1'">
        <div class="title"><img :src="large" /> <span>大型企业</span></div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in saas.large"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="small" /> <span>中小型企业</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in saas.small"
            :cardInfo="item"
            :key="index"
          />
        </div>
      </div>
      <div class="resource-enterprise" v-if="index === '2'">
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in paas"
            :cardInfo="item"
            :key="index"
          />
        </div>
      </div>
      <div class="resource-enterprise" v-if="index === '3'">
        <div class="title"><img :src="infor" /> <span>企业信息</span></div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in jinpin.infor"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>B2B 选型</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in jinpin.B2B"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>竞品排行</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in jinpin.rate"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>行业新闻</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in jinpin.news"
            :cardInfo="item"
            :key="index"
          />
        </div>
      </div>
      <div class="resource-enterprise" v-if="index === '4'">
        <div class="title"><img :src="infor" /> <span>咨询机构</span></div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in yanbao.zixun"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>报告收录</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in yanbao.baogao"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>咨询媒体</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in yanbao.meiti"
            :cardInfo="item"
            :key="index"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>数据机构</span>
        </div>
        <div class="resource-cards">
          <resource-card
            v-for="(item, index) in yanbao.shuju"
            :cardInfo="item"
            :key="index"
          />
        </div>
      </div>

      <div class="resource-enterprise" v-if="index === '5'">
        <div class="title"><img :src="infor" /> <span>财务</span></div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.caiwu"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>供应链</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.gongyl"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>人力资源</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.renlizy"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>CRM</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.crm"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>

        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>市场营销</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.shicyx"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>

        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>客户服务</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.kehfw"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>

        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>办公协同</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.bangxt"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>

        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>通用</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.tongy"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>

        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>数据分析</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_saas.shujfx"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
      </div>

      <div class="resource-enterprise" v-if="index === '6'">
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>应用开发</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_paas.yingyongkf"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
        <div class="title" style="margin-top: 20px">
          <img :src="b2b" /> <span>流程开发</span>
        </div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_paas.liuchengkf"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
        <div class="title"><img :src="infor" /> <span>数据分析平台</span></div>
        <div class="resource-cards">
          <resource-card-video
            v-for="(item, index) in GPT_in_paas.shujufxpt"
            :cardInfo="item"
            :key="index"
            :video="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import banner from "@/assets/img/resource/banner.png";
import large from "@/assets/img/resource/large.png";
import small from "@/assets/img/resource/small.png";
import infor from "@/assets/img/resource/infor.png";
import b2b from "@/assets/img/resource/b2b.png";
import news from "@/assets/img/resource/news.png";
import ResourceCard from "@/components/common/ResourceCard";
import ResourceCardVideo from "@/components/common/ResourceCardVideo";
import UeTabs from "@/components/home/UeTabs";
export const saas = {
  large: [
    {
      name: "SAP S/4 HANA Cloud",
      msg: "ERP全球领导者",
      tags: ["ERP", "销售管理", "服务管理"],
      url: "https://www.sap.cn/products/s4hana-erp/trial.html",
      user: {},
    },
    {
      name: "用友-NC Cloud",
      msg: "智能的大型企业数字化平台",
      tags: ["ERP", "销售管理", "共享"],
      url: "https://hc.yonyou.com/product.php?id=4",
      user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
    },
    {
      name: "用友-YonBIP",
      msg: "新一代的数智化商业创新平台",
      tags: ["ERP", "营销", "零售"],
      url: "https://www.yonyou.com/YonBIP/",
      user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
    },
    {
      name: "SAP Marketing Cloud",
      msg: "全旅程客户体验营销工具",
      tags: ["营销销售管理"],
      url: "https://www.sap.com/products/crm/marketing.html",
      user: {},
    },
  ],
  small: [
    {
      name: "Zoho-One",
      msg: "跨越CRM，Zoho新一代ERP",
      tags: ["ERP"],
      url: "https://www.zoho.com.cn/one/overview.html",
      user: {},
    },
    {
      name: "Odoo",
      msg: "大小企业都能用的ERP",
      tags: ["ERP"],
      url: "https://www.odoo.com/zh_CN/",
      user: {},
    },
    {
      name: "Intuit-quickbook",
      msg: "小微SaaS国际标杆品牌",
      tags: ["财务"],
      url: "https://quickbooks.intuit.com/global/?Country=China",
      user: {},
    },
    {
      name: "Xero",
      msg: "美丽的财务软件",
      tags: ["财务"],
      url: "https://www.xero.com/hk/",
      user: {},
    },
    {
      name: "好生意",
      msg: "用友旗下的营销+进销存软件",
      tags: ["进销存", "营销"],
      url: "https://hsy.chanjet.com/",
      user: {},
    },
    {
      name: "柠檬云",
      msg: "易用免费的小微企业SaaS",
      tags: ["财税", "进销存"],
      url: "https://www.ningmengyun.com/Default.aspx",
      user: {},
    },
    {
      name: "浪潮易云",
      msg: "小微ERP市场的追赶者",
      tags: ["财税", "进销存", "代账"],
      url: "http://www.eyun.cn/index.html",
      user: {},
    },
    {
      name: "智+",
      msg: "主打智能的新一代ERP",
      tags: ["财税", "进销存", "营销"],
      url: "https://z.chanjet.com/",
      user: {},
    },
    {
      name: "T+",
      msg: "用友中小企业的经典ERP",
      tags: ["ERP", "零售", "营销"],
      url: "https://t.chanjet.com/tplus/view/login.html?_from=exp",
      user: {},
    },
    {
      name: "用友-Yonsuite",
      msg: "助力成长型企业全面数字化",
      tags: ["ERP", "营销"],
      url: "https://yonsuite.diwork.com/#/",
      user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
    },
    {
      name: "Salesforce",
      msg: "CRM全球领导者",
      tags: ["营销销售管理", "客服", "BI"],
      url: "https://www.salesforce.com/cn/",
      user: {},
    },
    {
      name: "Zoho-CRMPlus",
      msg: "统一的客户体验平台",
      tags: ["营销销售管理", "客服"],
      url: "https://www.zoho.com.cn/crm/crmplus/",
      user: {},
    },
    {
      name: "销售易",
      msg: "国内CRM独角兽之一",
      tags: ["营销销售管理", "BI"],
      url: "https://www.xiaoshouyi.com/",
      user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
    },
    {
      name: "Shopify",
      msg: "全旅程购买服务的建店SaaS",
      tags: ["营销", "零售建店"],
      url: "https://www.shopify.cn/",
      user: {},
    },
    {
      name: "有赞",
      msg: "国内零售电商SaaS龙头",
      tags: ["营销", "零售建店", "销售管理"],
      url: "https://51kaidian.youzan.com/?from_source=baidu_sem_wsc_gn92612&keywordid=225747026309&bd_vid=7244534884646845165",
      user: {},
    },
    {
      name: "微盟",
      msg: "国内零售电商SaaS龙头",
      tags: ["营销", "零售建店", "销售管理"],
      url: "http://www.weimob.com/?channelSource=baidu10&JH=SCG%E3%80%90%E5%93%81%E7%89%8C%E3%80%91%E5%BE%AE%E7%9B%9F%E5%93%81%E7%89%8C&keyword=weimeng&bd_vid=7248383218144041588",
      user: {},
    },
    {
      name: "易企秀",
      msg: "内容创意+敏捷营销平台",
      tags: ["营销H5"],
      url: "https://store.eqxiu.com/?utm_id=1979&keywordid=221866341204&utm_source=baidu",
      user: {},
    },
    {
      name: "人人秀",
      msg: "一站式营销服务平台",
      tags: ["营销H5"],
      url: "https://rrx.cn/",
      user: {},
    },
    {
      name: "Airtable",
      msg: "新型的表格制作工具",
      tags: ["多维图表"],
      url: "https://airtable.com/",
      user: {},
    },
    {
      name: "飞书",
      msg: "企业协作平台",
      tags: ["多维图表", "协作平台"],
      url: "https://www.feishu.cn/",
      user: {},
    },
    {
      name: "Notion",
      msg: "集大成的个人信息处理工具",
      tags: ["多维图表", "办公笔记软件"],
      url: "https://www.notion.so/",
      user: {},
    },
    {
      name: "维格",
      msg: "科技新贵的协作神器",
      tags: ["多维图表", "协作平台"],
      url: "https://vika.cn/",
      user: {},
    },
    {
      name: "有格",
      msg: "轻松高效的数据管理工具",
      tags: ["多维图表"],
      url: "https://iyouge.com/ ",
      user: {},
    },
    {
      name: "monday",
      msg: "工作操作系统：管理一切的可视平台",
      tags: ["协作平台", "可视化展示"],
      url: "https://monday.com/",
      user: {},
    },
  ],
};
export const paas = [
  {
    name: "微软-Power Apps",
    msg: "移动应用低代码开发能力Top1",
    tags: ["低代码应用+AI"],
    url: "https://powerapps.microsoft.com/en-us/?cdn=disable",
    user: {},
  },
  {
    name: "微软-Power Automate",
    msg: "易用的流程可视化设计体验",
    tags: ["低代码业务流+RPA"],
    url: "https://flow.microsoft.com/zh-cn/",
    user: {},
  },
  {
    name: "微软-PowerVirtualAgents",
    msg: "无代码创建聊天机器人",
    tags: ["对话机器人"],
    url: "https://powervirtualagents.microsoft.com/zh-cn/",
    user: {},
  },
  {
    name: "炎黄盈动AWS PaaS",
    msg: "国内BPM领域老牌厂商",
    tags: ["低代码应用+业务流"],
    url: "https://www.actionsoft.com.cn/",
    user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
  },
  {
    name: "轻流",
    msg: "无代码工作流搭建平台",
    tags: ["零代码应用+业务流"],
    url: "https://qingflow.com/",
    user: {},
  },
  {
    name: "SAP Appgyver",
    msg: "国际第一款无代码开发平台",
    tags: ["零代码应用+业务流"],
    url: "https://www.appgyver.com/",
    user: {},
  },
  {
    name: "明道云",
    msg: "应用开发易用性业界标杆",
    tags: ["零代码应用"],
    url: "https://www.mingdao.com/",
    user: {},
  },
  {
    name: "Salesforce Lightning Platform",
    msg: "一次开发、多端适配",
    tags: ["低代码应用", "业务流"],
    url: "https://www.salesforce.com/cn/products/platform/app-dev/lightning-platform/",
    user: {},
  },
  {
    name: "Zoho Creator",
    msg: "表单驱动、适用于中小企业",
    tags: ["低代码应用"],
    url: "https://www.zoho.com/creator/",
    user: {},
  },
  {
    name: "Mendix",
    msg: "AI辅助业务流设计",
    tags: ["低代码应用+业务流"],
    url: "https://www.mendix.com/",
    user: {},
  },
  {
    name: "Oracle APEX",
    msg: "数据模型设计能力Top1",
    tags: ["低代码应用"],
    url: "https://apex.oracle.com/zh-cn/",
    user: {},
  },
  {
    name: "用友-Yonbuilder",
    msg: "一体化PaaS服务平台",
    tags: ["低代码应用+业务流RPA"],
    url: "https://developer.yonyoucloud.com/",
    user: { openId: "5f4e0134e4b0c43c22ebf1fa" },
  },
  {
    name: "SAP Analytics Cloud",
    msg: "自动化洞察智能BI",
    tags: ["BI"],
    url: "https://www.sap.com/products/cloud-analytics.html",
    user: {},
  },
  {
    name: "Zoho Analytics",
    msg: "自助式商业智能分析平台",
    tags: ["BI"],
    url: "https://www.zoho.com.cn/analytics/",
    user: {},
  },
  {
    name: "微软-Power BI",
    msg: "BI领域全球领导者",
    tags: ["BI"],
    url: "https://powerbi.microsoft.com/zh-cn/",
    user: {},
  },
  {
    name: "SAP 会话人工智能",
    msg: "简单创建强大的对话机器人",
    tags: ["对话机器人"],
    url: "https://cai.tools.sap/",
    user: {},
  },
  {
    name: "黑帕云",
    msg: "无代码搭建业务系统",
    tags: ["零代码应用", "多维图表"],
    url: "https://hipacloud.com/",
    user: {},
  },
];
export const jinpin = {
  infor: [
    {
      name: "IT桔子",
      msg: "互联网创业投资项目数据库",
      tags: ["投融资", "行业研究"],
      url: "https://www.itjuzi.com/",
    },
    {
      name: "烯牛数据",
      msg: "大数据驱动的金融数据公司",
      tags: ["行业研究", "投融资"],
      url: "http://www.xiniudata.com/",
    },
    {
      name: "Owler",
      msg: "提供企业最新业务信息",
      tags: ["企业信息"],
      url: "https://corp.owler.com/",
    },
    {
      name: "GoodFirms",
      msg: "IT公司和软件的研究与评论",
      tags: ["行业研究", "软件评论"],
      url: "https://www.goodfirms.co/",
    },
    {
      name: "dealroom",
      msg: "投资者和企业提供市场情报",
      tags: ["投融资", "收购新闻"],
      url: "https://app.dealroom.co/dashboard",
    },
    {
      name: "crunchbase",
      msg: "创业公司数据库",
      tags: ["财务状况", "收购新闻"],
      url: "https://www.crunchbase.com/",
    },
    {
      name: "天眼查（竞品部分信息）",
      msg: "商业查询平台",
      tags: ["企业信息"],
      url: "https://www.tianyancha.com/",
    },
    {
      name: "企查查",
      msg: "企业信息查询工具",
      tags: ["企业信息"],
      url: "https://www.qcc.com/ ",
    },
  ],
  B2B: [
    {
      name: "G2",
      msg: "B2B软件评论和服务网站",
      tags: ["评测", "排名", "选型"],
      url: "https://www.g2.com/",
    },
    {
      name: "Capterra",
      msg: "使用评论和价格查找软件",
      tags: ["评测", "排名", "选型"],
      url: "https://www.capterra.com/",
    },
    {
      name: "FinancesOnline",
      msg: "B2B软件评论交流平台",
      tags: ["行业洞察"],
      url: "https://financesonline.com/",
    },
    {
      name: "SaaSGenius",
      msg: "SaaS公司名录",
      tags: ["选型"],
      url: "https://www.saasgenius.com/",
    },
    {
      name: "TrustRadius",
      msg: "最受信任的商业技术网站",
      tags: ["评测", "行业洞察"],
      url: "https://www.trustradius.com/",
    },
    {
      name: "BetterBuys",
      msg: "专业的B2B选型网站",
      tags: ["选型", "专业评论"],
      url: "https://www.betterbuys.com/",
    },
    {
      name: "Software Advice",
      msg: "Gartner旗下软件咨询网站",
      tags: ["软件咨询", "选型"],
      url: "https://www.softwareadvice.com/",
    },
    {
      name: "SoftwareSuggest",
      msg: "帮助企业找到合适的软件",
      tags: ["软件信息", "用户评论"],
      url: "https://www.softwaresuggest.com/us/",
    },
    {
      name: "GetApp",
      msg: "比较和评估小型企业软件",
      tags: ["小微企业", "产品信息"],
      url: "https://www.getapp.com/",
    },
    {
      name: "TechnologyAdvice",
      msg: "为业务技术方提供专业服务",
      tags: ["用户评论", "评分"],
      url: "https://technologyadvice.com/",
    },
    {
      name: "crozdesk",
      msg: "企业软件搜索平台",
      tags: ["排名", "产品信息"],
      url: "https://crozdesk.com/",
    },
    {
      name: "ITCentralStation",
      msg: "企业技术产品评论网站",
      tags: ["用户评论", "选型"],
      url: "https://www.itcentralstation.com/",
    },
    {
      name: "谷歌应用市场",
      msg: "谷歌应用市场",
      tags: ["选型", "评分"],
      url: "https://gsuite.google.com/marketplace/",
    },
    {
      name: "36kr企服点评",
      msg: "企业服务软件选购平台",
      tags: ["用户评论", "评分", "排名"],
      url: "https://www.36dianping.com/z",
    },
  ],
  rate: [
    {
      name: "Gartner（魔力象限报告中）",
      msg: "提供竞争定位的专业平台",
      tags: ["Gartner", "魔力象限"],
      url: "https://www.gartner.com/en/information-technology/research/magic-quadrant",
    },
    {
      name: "Nucleus Research（价值矩阵报告中）",
      msg: "专注于ROI的全球提供商",
      tags: ["ROI"],
      url: "https://nucleusresearch.com/valuematrix/",
    },
  ],
  news: [
    {
      name: "ERP Solution Review",
      msg: "顶级ERP软件信息提供商",
      tags: ["解决方案", "新闻"],
      url: "https://solutionsreview.com/enterprise-resource-planning/",
    },
    {
      name: "ERP news（ERP厂商的资讯信息）",
      msg: "提供ERP新闻的专业门户",
      tags: ["新闻", "客户案例"],
      url: "https://erpnews.com/",
    },
    {
      name: "ERP Focus（ERP企业能力对比）",
      msg: "面向专业人员的资源网站",
      tags: ["新闻", "工具", "研究"],
      url: "https://www.erpfocus.com/",
    },
  ],
};

export const yanbao = {
  zixun: [
    {
      imgurl: "static/img/resource/gartner.png",
      name: "Gartner",
      msg: "IT研究与顾问咨询公司",
      tags: ["魔力象限"],
      url: "https://www.gartner.com/en",
    },
    {
      imgurl: "static/img/resource/IDC.png",
      name: "IDC",
      msg: "科技咨询公司",
      tags: ["IT", "数字化转型"],
      url: "https://www.idc.com/cn",
    },
    {
      imgurl: "static/img/resource/Forrester.png",
      name: "Forrester",
      msg: "研究和咨询公司",
      tags: ["魔力象限"],
      url: "https://www.forrester.com//search?N=10001+5001&range=504005&sort=3&searchRefinement=reports",
    },
    {
      imgurl: "static/img/resource/bimawei.png",
      name: "毕马威",
      msg: "审计、税务和咨询服务",
      tags: ["B2B"],
      url: "https://home.kpmg/cn/zh/home.html",
    },
    {
      imgurl: "static/img/resource/puhua.png",
      name: "普华永道",
      msg: "全方位的业务咨询服务",
      tags: ["B2B"],
      url: "https://www.pwccn.com/zh/research-and-insights.html",
    },
    {
      imgurl: "static/img/resource/dele.png",
      name: "德勤",
      msg: "全方位的业务咨询服务",
      tags: ["B2B"],
      url: "https://www2.deloitte.com/cn/zh.html",
    },
    {
      imgurl: "static/img/resource/anyong.png",
      name: "安永",
      msg: "审计、税务和咨询服务",
      tags: ["B2B"],
      url: "https://www.ey.com/zh_cn",
    },
    {
      imgurl: "static/img/resource/nielsen.png",
      name: "尼尔森",
      msg: "市场监测和数据分析公司",
      tags: ["零售", "财务"],
      url: "https://www.nielsen.com/cn/zh/insights/",
    },
    {
      imgurl: "static/img/resource/McKinsey.png",
      name: "麦肯锡",
      msg: "管理咨询公司",
      tags: ["数字化", "CEO"],
      url: "https://www.mckinsey.com.cn/",
    },
    {
      imgurl: "static/img/resource/aizesheng.png",
      name: "埃森哲",
      msg: "企业绩效提升专家",
      tags: ["数字化转型"],
      url: "https://www.accenture.com/cn-zh",
    },
    {
      imgurl: "static/img/resource/IBM.png",
      name: "IBM ",
      msg: "管理+IT咨询公司",
      tags: ["混合云", "AI"],
      url: "https://www.ibm.com/cn-zh",
    },
    {
      imgurl: "static/img/resource/IBM2.png",
      name: "IBM商业价值研究院",
      msg: "IBM 商业价值研究院",
      tags: ["行业数据"],
      url: "https://www.ibm.com/cn-zh/services/insights/institute-business-value",
    },
    {
      imgurl: "static/img/resource/BCG.png",
      name: "BCG ",
      msg: "企业管理咨询公司",
      tags: ["企业管理"],
      url: "https://www.bcg.com/zh-cn/",
    },
    {
      imgurl: "static/img/resource/Sinobridge.png",
      name: "Sinobridge（中桥）",
      msg: "专注于数据中心领域",
      tags: ["云", "大数据"],
      url: "http://www.sino-bridges.com/zh/company/aboutus",
    },
    {
      imgurl: "static/img/resource/avanade.png",
      name: "avanade（埃维诺）",
      msg: "微软与埃森哲合作的IT咨询公司",
      tags: ["数字化转型"],
      url: "https://www.avanade.com/zh-cn",
    },
    {
      imgurl: "static/img/resource/Morgan.png",
      name: "摩根大通",
      msg: "全球金融服务公司",
      tags: ["金融"],
      url: "https://www.jpmorganchina.com.cn/zh/about-us",
    },
    {
      imgurl: "static/img/resource/Bain.png",
      name: "贝恩",
      msg: "全球战略咨询公司",
      tags: ["企业策略"],
      url: "https://www.bain.cn/",
    },
    {
      imgurl: "static/img/resource/RolandBerger.png",
      name: "罗兰贝格",
      msg: "战略管理咨询公司",
      tags: ["企业管理"],
      url: "https://www.rolandberger.com/zh/?country=CN",
    },
    {
      imgurl: "static/img/resource/36.png",
      name: "36氪研究院",
      msg: "收录高质量研究报告",
      tags: ["大数据", "SaaS"],
      url: "https://36kr.com/academe.html",
    },
    {
      imgurl: "static/img/resource/Panorama.png",
      name: "Panorama",
      msg: "独立的ERP咨询顾问",
      tags: ["ERP"],
      url: "https://www.panorama-consulting.com/",
    },
    {
      imgurl: "static/img/resource/IDG.png",
      name: "IDG",
      msg: "美国国际数据集团",
      tags: ["云计算", "CIO"],
      url: "https://www.idg.com/tools_type/research/?fwp_resource=white-paper",
    },
    {
      imgurl: "static/img/resource/Ventana.png",
      name: "Ventana Research",
      msg: "研究和咨询服务公司",
      tags: ["ERP"],
      url: "https://www.ventanaresearch.com/",
    },
  ],
  baogao: [
    {
      imgurl: "static/img/resource/airui.png",
      name: "艾瑞网",
      msg: "行业资讯、数据、报告",
      tags: ["B2C"],
      url: "http://report.iresearch.cn/",
    },
    {
      imgurl: "static/img/resource/199IT.png",
      name: "199IT",
      msg: "报告收录网站",
      tags: ["B2B", "云计算", "AI"],
      url: "http://www.199it.com/",
    },
    {
      imgurl: "static/img/resource/itjuzi.png",
      name: "IT桔子",
      msg: "SaaS类信息收录最全网站",
      tags: ["SaaS"],
      url: "https://www.itjuzi.com/report",
    },
    {
      imgurl: "static/img/resource/yiguan.png",
      name: "易观分析",
      msg: "行业数据分析、研究报告",
      tags: ["SaaS", "营销", "互联网"],
      url: "https://www.analysys.cn/article/analysis/",
    },
    {
      imgurl: "static/img/resource/ali.png",
      name: "阿里研究院",
      msg: "信息经济领域研究报告",
      tags: ["电子商务", "小微企业"],
      url: "http://www.aliresearch.com/cn/presentation",
    },
    {
      imgurl: "static/img/resource/T.png",
      name: "T媒体",
      msg: "研究型媒体平台",
      tags: ["SaaS", "CRM"],
      url: "http://www.cniteyes.com/document",
    },
    {
      imgurl: "static/img/resource/yidong.png",
      name: "移动观象台",
      msg: "互联网用户数据洞察",
      tags: ["房产", "金融", "营销"],
      url: "http://mi.talkingdata.com/reports.html?category=all",
    },
    {
      imgurl: "static/img/resource/aimei.png",
      name: "艾媒网 ",
      msg: "经济领域的数据分析报告",
      tags: ["零售", "金融"],
      url: "http://www.iimedia.cn/#shuju",
    },
    {
      imgurl: "static/img/resource/shujuguan.png",
      name: "数据观",
      msg: "报告收录网站",
      tags: ["大数据"],
      url: "http://www.cbdio.com/",
    },
    {
      imgurl: "static/img/resource/shujuju.png",
      name: "数据局",
      msg: "报告收录网站",
      tags: ["行业数据"],
      url: "http://www.shujuju.cn/",
    },
    {
      imgurl: "static/img/resource/baogaolaile.png",
      name: "报告来了",
      msg: "报告收录网站",
      tags: ["行业数据"],
      url: "http://www.baogaolaile.com/",
    },
    {
      imgurl: "static/img/resource/baogaoyanjiu.png",
      name: "报告与研究",
      msg: "gartner、Forrest等报告合集",
      tags: ["Gartner", "Forrest"],
      url: "https://www.episerver.com/expertise/reports-and-studies",
    },
    {
      imgurl: "static/img/resource/linkin.png",
      name: "领英数据报告",
      msg: "领英大数据的洞察报告",
      tags: ["人力资源"],
      url: "https://business.linkedin.com/zh-cn/talent-solutions/recruiting-resources-tips",
    },
    {
      imgurl: "static/img/resource/huibo.png",
      name: "慧博投研资讯",
      msg: "专业的投资研究报告",
      tags: ["行业分析"],
      url: "http://www.hibor.com.cn/microns_13.html",
    },
    {
      imgurl: "static/img/resource/pijiang.png",
      name: "皮匠网",
      msg: "报告收录网站",
      tags: ["数字化", "AI"],
      url: "https://www.3mbang.com/",
    },
    {
      imgurl: "static/img/resource/baogaoshe.png",
      name: "报告社",
      msg: "报告收录网站",
      tags: ["科技", "互联网", "零售", "金融"],
      url: "https://www.baogaoshe.com/",
    },
  ],
  meiti: [
    {
      imgurl: "static/img/resource/51CTO.png",
      name: "51CTO",
      msg: "程序员社区",
      tags: ["云计算", "大数据"],
      url: "https://www.51cto.com/",
    },
    {
      imgurl: "static/img/resource/csdn.png",
      name: "CSDN-专业开发者社区",
      msg: "IT技术交流平台",
      tags: ["IT"],
      url: "https://www.csdn.net/",
    },
    {
      imgurl: "static/img/resource/zhongxin.png",
      name: "中信证券研究报告",
      msg: "行业调研报告",
      tags: ["金融", "云计算"],
      url: "http://www.cs.ecitic.com/newsite/zxzx/yjbg/index_2.html",
    },
    {
      imgurl: "static/img/resource/qie.png",
      name: "企鹅智酷",
      msg: "互联网产业趋势",
      tags: ["B2C", "互联网"],
      url: "https://tech.qq.com/biznext/bizlist.htm",
    },
    {
      name: "牛透社",
      msg: "B2B、SaaS企业服务洞察",
      tags: ["B2B", "SaaS"],
      url: "https://www.niutoushe.com/",
    },
    {
      name: "计世资讯",
      msg: "中国权威ICT研究咨询机构",
      tags: ["IT"],
      url: "http://www.ccwresearch.com.cn/index.htm",
    },
    {
      name: "何马网",
      msg: "人力资源信息与交易平台",
      tags: ["人力字眼"],
      url: "https://www.hroot.com/",
    },
    {
      name: "ERP NEWS",
      msg: "ERP软件解决方案",
      tags: ["ERP"],
      url: "https://erpnews.com/magazine/",
    },
    {
      name: "ERP _x0008_FOCUS",
      msg: "ERP客户线索收集平台",
      tags: ["ERP"],
      url: "https://www.erpfocus.com/",
    },
    {
      name: "Erp in News ",
      msg: "ERP解决方案",
      tags: ["ERP"],
      url: "https://erpinnews.com/",
    },
    {
      name: "IT NEWS",
      msg: "IT技术新闻网站",
      tags: ["IT"],
      url: "https://www.itnews.com/category/enterprise-resource-planning/",
    },
    {
      name: "Cloud Tech",
      msg: "提供云技术的最新见解",
      tags: ["云计算", "SaaS"],
      url: "https://www.cloudcomputing-news.net/categories/erp/",
    },
    {
      name: "GigaOm",
      msg: "美国的科技博客媒体",
      tags: ["云", "AI"],
      url: "https://gigaom.com/",
    },
  ],
  shuju: [
    {
      name: "国家统计局 ",
      msg: "国家统计局",
      tags: ["制造业", "房地产"],
      url: "http://www.stats.gov.cn/tjsj/",
    },
    {
      name: "中国信息通信研究院",
      msg: "企业信息化、工业互联网报告",
      tags: ["ICT"],
      url: "http://www.caict.ac.cn/",
    },
    {
      name: "中国互联网络信息中心",
      msg: "互联网细分领域研究报告",
      tags: ["互联网"],
      url: "http://www.cnnic.net.cn/",
    },
    {
      name: "中国市场情报中心",
      msg: "中国市场情报中心",
      tags: ["电子信息", "房地产"],
      url: "http://www.ccidreport.com/",
    },
  ],
};

export const GPT_in_saas = {
  caiwu: [
    {
      imgurl: "",
      name: "Intuit Assist in QuickBooks",
      msg: "嵌入从建账到开始业务的过程中，基于系统数据提供分析、决策建议。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3e9c85576678021791622423/qT7r4j7XAx0A.mp4?t=bbf81e00&sign=7debccd021ac312b728a686572084b68"
    },
    {
      imgurl: "",
      name: "Intuit Assist in TurboTax",
      msg: "帮助用户简化报税流程，减少出错，回答用户问题，并给用户信息。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"], 
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2ecfe795576678021791657765/crMd7YRRCtsA.mp4?t=bbf81e00&sign=d61ace4f22584455425064a74fae36b1"
    },
    {
      imgurl: "",
      name: "Intuit Assist in Credit Karma",
      msg: "监测系统数据，给出获得更多信用奖励的建议，以及融资行动指导。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
       videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/0183b8335576678021782582357/XexyXL0SLsQA.mp4?t=bbf81e00&sign=208bd04d889bc991a9d38b6643cc6afe"
    },
    {
      imgurl: "",
      name: "Intuit Assist in MailChimp",
      msg: "与客户邮件沟通过程中辅助邮件回复，并判断是否合格的潜在客户。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"], 
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/014f2d975576678021782555973/55K3DNqTPkEA.mp4?t=bbf81e00&sign=a7d38fb463c25b5dfdaa318c0f699650"
    },
    {
      imgurl: "",
      name: "Intuit Assist in MailChimp",
      msg: "辅助撰写营销邮件和找到客群，并用自然语言输出营销活动的数据监测报告。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/014f2d975576678021782555973/55K3DNqTPkEA.mp4?t=bbf81e00&sign=a7d38fb463c25b5dfdaa318c0f699650"
    },
    {
      imgurl: "",
      name: "YonGPT-企业收入/利税经营分析",
      msg: "感知企业产销存各领域数据的关联和归因，进行推理式经营洞察分析。",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ea735576678021791622479/AipFJAoxoIEA.mp4?t=bbf81e00&sign=b6921c5fa39ec38387895cffaaa831aa"
    },

    {
      imgurl: "",
      name: "元年C1智答",
      msg: "发现经营风险，洞见问题，预测效益，生成简报，自动挖掘分析信息并形成报告。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78a5a5e75576678021787122071/vYAyB9GGkuIA.mp4?t=bbf81e00&sign=9c595c19e949a8d4f609f6ddacd3b50f"

    },
    {
      imgurl: "",
      name: "令才",
      msg: "非标票据定向数据结构化；自动理解纸面财务规则，实现规则自匹配、自调整。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
      url: "https://appfcn0j5fl2528.h5.xiaoeknow.com/v2/course/alive/l_64917b34e4b0b2d1c4270428?type=2&app_id=appfCn0J5fL2528&available=true&share_user_id=u_64b543c04acb7_g5jHeoyOGb&share_type=5&scene=%E5%88%86%E4%BA%AB&share_scene=1&entry=2&entry_type=2002"
    },
    {
      imgurl: "",
      name: "Brex Financial Assistant",
      msg: "预算控制、趋势分析、异常监测、支付方式建议、供应商动态趋势可视化。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"],
       videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/0349db505576678021782605943/aIlOtbs4yrcA.mp4?t=bbf81e00&sign=fabe21ff8b28e25fbea88c962e6a48da"

    },
    {
      imgurl: "",
      name: "FinanceGPT",
      msg: "通过结构化与非结构化的业务信息组合，自动生成报告。",
      tags: ["逻辑推理分析", "【结构化-非结构化】处理分析"], 
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78a7d7b05576678021787126094/9a0xv73tW0kA.mov?t=bbf81e00&sign=85c19d691211d25b570388ebea834c8b"
    }
  ],
  gongyl: [
    {
      imgurl: "",
      name: "YonGPT-智能生单",
      msg: "基于销售业务员和客户的友空间对话，收集信息提取摘要，自动创建销售订单。",
      tags: ["【非结构化-结构化】处理分析", "生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ea735576678021791622479/AipFJAoxoIEA.mp4?t=bbf81e00&sign=b6921c5fa39ec38387895cffaaa831aa",
    },
    {
      imgurl: "",
      name: "4Paradigm",
      msg: "SageGPT式说	图表形式回答复杂数据问题：查询相关数据图表，呈现相应的图表、表格数据。",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2ebe9d95576678021791655857/0cwECVaTL4MA.mp4?t=bbf81e00&sign=a90e8b4c7ddd2e77b2d81911ab18aa88",
    },
    {
      imgurl: "",
      name: "4Paradigm",
      msg: "SageGPT式说	学习企业文献并解答问题：支持对话式提问企业文献内容。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2ebe9d95576678021791655857/0cwECVaTL4MA.mp4?t=bbf81e00&sign=a90e8b4c7ddd2e77b2d81911ab18aa88",
    },
    {
      imgurl: "",
      name: "4Paradigm",
      msg: "SageGPT式说	自主分析并提供解决对策：对话式提出问题，获取解决方案。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2ebe9d95576678021791655857/0cwECVaTL4MA.mp4?t=bbf81e00&sign=a90e8b4c7ddd2e77b2d81911ab18aa88",
    },
  ],
  renlizy: [
    {
      imgurl: "",
      name: "Moka Eva",
      msg: "一站式完成从招聘需求编写到激活企业内部人才库匹配候选人。",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d82feb5576678021791642910/657SDzDzaWoA.mp4?t=bbf81e00&sign=d7cf327dd54181951028d9e1d6d85b63",
    },
    {
      imgurl: "",
      name: "Moka Eva",
      msg: "招聘岗位面试进展、OKR制定进展结果分析",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d82feb5576678021791642910/657SDzDzaWoA.mp4?t=bbf81e00&sign=d7cf327dd54181951028d9e1d6d85b63",
    },
    {
      imgurl: "",
      name: "Moka Eva",
      msg: "员工出勤、招聘转化率、用工留存率等分析洞察",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d82feb5576678021791642910/657SDzDzaWoA.mp4?t=bbf81e00&sign=d7cf327dd54181951028d9e1d6d85b63",
    },
    {
      imgurl: "",
      name: "Moka Eva",
      msg: "辅助面试，生成面试评价内容、面试问题",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d82feb5576678021791642910/657SDzDzaWoA.mp4?t=bbf81e00&sign=d7cf327dd54181951028d9e1d6d85b63",
    },
    {
      imgurl: "",
      name: "Moka Eva",
      msg: "员工自助咨询智能问答、辅助启动业务流程",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d82feb5576678021791642910/657SDzDzaWoA.mp4?t=bbf81e00&sign=d7cf327dd54181951028d9e1d6d85b63",
    },
    {
      imgurl: "",
      name: "SenGPT",
      msg: "撰写职位JD",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/01845a195576678021782583875/UgWPyuo6XEEA.mp4?t=bbf81e00&sign=7d353dfaf649e1d5202bac7420b8b70a",
    },
    {
      imgurl: "",
      name: "SenGPT",
      msg: "评估简历:自动发起、自动筛选、自助约面",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78b8eff15576678021787134618/NK4v4lPf8AAA.mp4?t=bbf81e00&sign=3724e6a778f6e0b0e71f9608cc283df2",
    },
    {
      imgurl: "",
      name: "SenGPT",
      msg: "生成海报",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2c58baf5576678021791631961/DOQB729QKk4A.mp4?t=bbf81e00&sign=4528831eea70f5b9d852e6a45e65d8e1",
    },
    {
      imgurl: "",
      name: "小薪",
      msg: "分析洞察，生成报告&看板、辅助视频面试",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2e927905576678021791650745/88jqKbs6CLcA.mp4?t=bbf81e00&sign=5073b9013fa52afaf855ef79cdbe7ec7",
    },
    {
      imgurl: "",
      name: "SAP SuccessFactors Recruiting",
      msg: "集成Microsoft 365 Copilo在产品中，一站式完成招聘自动化",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/034a460f5576678021782606176/V1niIEuxSCgA.mov?t=bbf81e00&sign=78ff5eeff2e6a7494fbf6c0ef0f9ea9b",
    },
    {
      imgurl: "",
      name: "Oracle Fusion Cloud Human Capital Management",
      msg: "提供智能化套件，包括一流的员工体验、云原生基础设施和持续创新",
      tags: ["逻辑推理分析"],
      url: "https://www.sohu.com/a/692483442_121118996",
    },
    {
      imgurl: "",
      name: "YonGPT -智能招聘",
      msg: "一站式完成智能招聘全过程，包含分析洞察",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/79135e9a5576678021787184388/QeOqsGSWGjEA.mp4?t=bbf81e00&sign=a0bfd25b1ae1c419cd3cde1c72eefea6",
    },
    {
      imgurl: "",
      name: "YonGPT-智能招聘",
      msg: "撰写JD、结合行业特点和企业需求进行目标人才推荐、生成面试评价。",
      tags: ["逻辑推理分析", "【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ea735576678021791622479/AipFJAoxoIEA.mp4?t=bbf81e00&sign=b6921c5fa39ec38387895cffaaa831aa",
    },
  ],

  crm: [
    {
      imgurl: "",
      name: "Microsoft Viva Sales",
      msg: "通过 AI 提取关键信息，生成的电子邮件与客户沟通",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Microsoft Viva Sales",
      msg: "根据 CRM 和会议数据，生成会议摘要及时跟进客户",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Dynamics 365 Marketing",
      msg: "使用自然语言描述客户群体，生成一个支持检索辅助功能的全新目标客户类别",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Dynamics 365 Business Centra",
      msg: "基于产品列表与产品参数，自动生成商品描述",
      tags: ["【结构化-非结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Dynamics 365 Supply Chain Management",
      msg: "能主动为影响供应链流程的事件发出告警，并生成的电子邮件向受到影响的合作伙伴发出预警",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Commerce GPT",
      msg: "支持动态的产品描述：自动为商家填写缺失的商品描述数据。",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ee285576678021791622531/feDXKA8w7sMA.mp4?t=bbf81e00&sign=a80b74caf42ea8c6a84aaf2278e9abdf",
    },
    {
      imgurl: "",
      name: "Commerce GPT",
      msg: "创建促销活动：利用生成技术更快地创建和部署促销活动。",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ee285576678021791622531/feDXKA8w7sMA.mp4?t=bbf81e00&sign=a80b74caf42ea8c6a84aaf2278e9abdf",
    },
    {
      imgurl: "",
      name: "Sales GPT",
      msg: "销售电子邮件：自动生成包含上下文信息的个性化电子邮件。",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d9c9125576678021791645671/1AXN4WjG6X8A.mp4?t=bbf81e00&sign=ddafe1059699305cee0303599b156228",
    },
    {
      imgurl: "",
      name: "Sales GPT",
      msg: "通过自动记录和总结通话以及设置跟进措施，来帮助提高销售人员的工作效率。",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d9c9125576678021791645671/1AXN4WjG6X8A.mp4?t=bbf81e00&sign=ddafe1059699305cee0303599b156228",
    },
    {
      imgurl: "",
      name: "Now Assist for Virtual Agent",
      msg: "帮助客服人员进行提单等问题的总结，并进生成推荐的解决方案。",
      tags: ["【非结构化-结构化】处理分析", "逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78efc6765576678021787165664/jTIHHdhkMUwA.mov?t=bbf81e00&sign=8d616dde8bb9344b093265c53fc04820",
    },
    {
      imgurl: "",
      name: "Now Assist for Virtual Agent",
      msg: "向顾客和员工提供自然语言对话方式的自助式提单服务",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78efc6765576678021787165664/jTIHHdhkMUwA.mov?t=bbf81e00&sign=8d616dde8bb9344b093265c53fc04820",
    },
  ],

  shicyx: [
    {
      imgurl: "",
      name: "Marketing GPT",
      msg: "帮助营销人员快速生成创建目标客户分类",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ee285576678021791622531/feDXKA8w7sMA.mp4?t=bbf81e00&sign=a80b74caf42ea8c6a84aaf2278e9abdf",
    },
    {
      imgurl: "",
      name: "Marketing GPT",
      msg: "生成电子邮件内容，减少写作工作量，与客户沟通",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ee285576678021791622531/feDXKA8w7sMA.mp4?t=bbf81e00&sign=a80b74caf42ea8c6a84aaf2278e9abdf",
    },
  ],
  kehfw: [
    {
      imgurl: "",
      name: "Dynamics 365 Customer Service",
      msg: "针对聊天对话和电子邮件中的问题，撰写出符合上下文语境的答案",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Dynamics 365 Customer Insights",
      msg: "使用自然语言与数据平台进行对话，生成定制化和目标明确的客户分类",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/00f3092d5576678021782502836/8NPeTjvUv5cA.mp4?t=bbf81e00&sign=e3d4c417117df012a848a16f4add2b93",
    },
    {
      imgurl: "",
      name: "Service GPT",
      msg: "服务回复将根据实时数据源自动生成个性化响应，解决客户问题。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/013bf7535576678021782543819/yFQ2G2QMHOAA.mp4?t=bbf81e00&sign=914743efbc9ae42d7b90f4bf70cf3251",
    },
    {
      imgurl: "",
      name: "Service GPT",
      msg: "工作摘要将根据案例数据和客户历史记录创建服务案例和客户参与的总结摘要。",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d9c9125576678021791645671/1AXN4WjG6X8A.mp4?t=bbf81e00&sign=ddafe1059699305cee0303599b156228",
    },
    {
      imgurl: "",
      name: "Service GPT",
      msg: "移动工作简报：在一线服务团队赴约之前汇总关键信息来为预约做好准备",
      tags: ["【非结构化-结构化】处理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d9c9125576678021791645671/1AXN4WjG6X8A.mp4?t=bbf81e00&sign=ddafe1059699305cee0303599b156228",
    },
    {
      imgurl: "",
      name: "Service GPT",
      msg: "知识文章：自动起草知识文章以节省客服人员和移动工作人员的时间。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/7901c5525576678021787175056/AAd0zTc4glUA.mp4?t=bbf81e00&sign=9196124f98b3a562a37c178440791a97",
    },

  ],
  bangxt: [
    {
      imgurl: "",
      name: "Slack GPT",
      msg: "基于对话消息输出摘要，在用户需要起草消息时辅助写作。",
      tags: ["【结构化-非结构化】处理分析"],
      url: "https://www.salesforce.com/news/stories/chatgpt-app-for-slack/",
    },
    {
      imgurl: "",
      name: "YonGPT-智能大搜",
      msg: "获取目标相关资料，并能通过大模型提供各类资料的要点，方便用户获取信息。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2b3ea735576678021791622479/AipFJAoxoIEA.mp4?t=bbf81e00&sign=b6921c5fa39ec38387895cffaaa831aa",
    },
  ],
  tongy: [
    {
      imgurl: "",
      name: "Now Assist for Search",
      msg: "通过搜索引擎在ServiceNow上查找想要的内容如文档、知识库等类型的数据。",
      tags: ["信息搜索加强"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78efc6765576678021787165664/jTIHHdhkMUwA.mov?t=bbf81e00&sign=8d616dde8bb9344b093265c53fc04820",
    },
  ],

  shujfx: [
    {
      imgurl: "",
      name: " Tableau Pulse",
      msg: "自动生成分析摘要，提供深入分析提问指令建议，生成可视化分析结果。",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/7901e2725576678021787175704/FMQJOtXJa24A.mp4?t=bbf81e00&sign=a227894358ac114d004e2b6af82ff930",
    },
    {
      imgurl: "",
      name: "问卷星",
      msg: "基于大语言模型对统计结果分析，系统会自动生成一段文字描述的分析",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2c71ff05576678021791634572/YtQ4OWXvvRkA.mov?t=bbf81e00&sign=cfe53c7269a7f537576e5a065c58c987",
    },
    {
      imgurl: "",
      name: "网易数帆-轻舟",
      msg: "利用自然语言生成技术，做到即时智能查询、流畅智能交互、数据分析",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/0118dffa5576678021782525889/JD7uWXkgSa8A.mp4?t=bbf81e00&sign=6d022ec189b520aff46b5cfc63387862",
    },
  ],

};

export const GPT_in_paas = {
  shujufxpt: [
    {
      imgurl: "",
      name: "Power BI copilot",
      msg: "用自然语言描述需求，系统自动生成包含可交互图表的数据看板",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/789395635576678021787112230/Ix4TWuKapKEA.mov?t=bbf81e00&sign=568ecbb90bf72ee379c6dac02ee8940b",
    },
    {
      imgurl: "",
      name: "Power BI copilot",
      msg: "基于自然语言的询问，对当前看板的数据进行深入分析和总结性分析",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2ee16d85576678021791659735/RMQBCjH9ON0A.mp4?t=bbf81e00&sign=ffa4d2208227a2e7999f56ac4be59541",
    },
    {
      imgurl: "",
      name: "Sugar BI 文心问数",
      msg: "以问答的交互形式，提出业务问题，系统将以图表的形式返回答案及业务结论。",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/0105260b5576678021782512941/kFSZ5ngfPQoA.mp4?t=bbf81e00&sign=3fe9515b7cc4931a8e6d84d7c6f0cbc5",
    },
    {
      imgurl: "",
      name: "Sugar BI 文心问数",
      msg: "创建报表/大屏看板时，通过问答交互得到想要的图表类型，一键生成卡片",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2a38bf15576678021791615943/Ztk6xybn7s4A.mp4?t=bbf81e00&sign=e6ba53e3c13f5d1743254173e1af7ec2",
    },
    {
      imgurl: "",
      name: "有数ChatBI",
      msg: "用自然语言对数据表进行搜索查询、分类、排序、行列统计等操作",
      tags: ["信息搜索加强"],
      url: "https://www.bilibili.com/video/BV1h14y1D7mt/?vd_source=2fe05b395ffc74e16c7598092279847b",
    },
  ],
  yingyongkf: [
    {
      imgurl: "",
      name: "Power App copilot",
      msg: "通过对话（自然语言）即可创建应用程序（包括数据表和后端逻辑）",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/012d08175576678021782539098/2i5SXnn8mucA.mp4?t=bbf81e00&sign=76dd828a17f573fa33c2f5f851e6f536",
    },
    {
      imgurl: "",
      name: "Power Pages copilot",
      msg: "将Copilot内置在网页开发组件里，以便通过自然语言  快速生成网页",
      tags: ["【结构化 - 非结构化】","处理分析生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/034a5b0f5576678021782606653/2NYyG8IYVo0A.mp4?t=bbf81e00&sign=08ae207f60e78466674f27482820e67c",
    },
    {
      imgurl: "",
      name: "Power Virtual Agents copilot",
      msg: "用简单描述创建对话机器人的对话流程，并可进行添加或更新现有主题中的内容",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2d81aca5576678021791642423/2qua4NVAcvkA.mov?t=bbf81e00&sign=63d8b1f518674cc723bfc8d0cadb1448",
    },
    {
      imgurl: "",
      name: "Now Assist for Virtual Agent",
      msg: "通过代码生成帮助开发人员更快的自定义应用程序",
      tags: ["逻辑推理分析"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78efc6765576678021787165664/jTIHHdhkMUwA.mov?t=bbf81e00&sign=8d616dde8bb9344b093265c53fc04820",
    },
    {
      imgurl: "",
      name: "Salesforce Apex GPT",
      msg: "利用Apex GPT，辅助代码开发场景，提高代码质量",
      tags: ["生成代码执行操作"],
      url: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78efc6765576678021787165664/jTIHHdhkMUwA.mov?t=bbf81e00&sign=8d616dde8bb9344b093265c53fc04820",
    },
    {
      imgurl: "",
      name: "宜搭AI Copilot",
      msg: "AI Copilot让应用开发更简单",
      tags: ["生成代码执行操作"],
      url: "https://lujxa1.aliwork.com/o/YIDA_AI",
    },
    {
      imgurl: "",
      name: "伙伴云AI搭建",
      msg: "AI搭建用于辅助搭建应用",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/788337f45576678021787105785/JKOE9IGmGcgA.mov?t=bbf81e00&sign=f8abcf5dfaa43e86e04eaf90110f5479",
    },
    {
      imgurl: "",
      name: "4Paradigm SageGPT式说",
      msg: "生成程序代码：通过自然语言交互，帮助开发者生成程序代码、提高应用开发效率",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78dda52f5576678021787155442/wlkkGARWglIA.mp4?t=bbf81e00&sign=a3675364325bed14c42426f174874568",
    },
    {
      imgurl: "",
      name: "网易数帆-轻舟",
      msg: "通过自然语言交互式智能编程，同时利用机器学习，帮助开发者提高开发效率",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/012b7c155576678021782536666/MKhzVqonfNYA.mp4?t=bbf81e00&sign=d05131868ce7f3c06b70372f874233fd",
    },
    {
      imgurl: "",
      name: "网易数帆-轻舟",
      msg: "智能D2C：通过深度学习和计算机视觉等技术来分析和理解业务原型稿中的元素",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78bba1b55576678021787139365/BWvydnrxnbwA.mp4?t=bbf81e00&sign=de1d65ba965fcb557334f6e1c2682ba6",
    },
  ],
  liuchengkf: [
    {
      imgurl: "",
      name: "Power Automate copilot",
      msg: "业务用户用自然语言描述流程任务，copilot则自动生成对应的流程模板",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/78a5b2b25576678021787122379/oOHN1HJXolwA.mov?t=bbf81e00&sign=c7ba0a47748a31e7caf77bdf3fd73a12",
    },
    {
      imgurl: "",
      name: "flow GPT",
      msg: "用户可以使用对话界面创建和修改自动化，这从根本上简化了流程创建过程，并显着降低了非技术用户的障碍。",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2fde9355576678021791665285/0zMC1O2gLtIA.mov?t=bbf81e00&sign=890d34d5de6870831907e103e73cc605",
    },
    {
      imgurl: "",
      name: "zapier",
      msg: "通过自然语言构建自动化应用的链接",
      tags: ["生成代码执行操作"],
      videoUrl: "https://1500025544.vod-qcloud.com/6cbe757cvodcq1500025544/a2fcc6e45576678021791663000/7VBlua0PVpgA.mov?t=bbf81e00&sign=12577074714e07920c7f8289d64840bf",
    },
  ],
};


export default {
  name: "resource",
  data() {
    return {
      banner,
      large,
      small,
      infor,
      b2b,
      news,
      index: "0",
      tabs: [
        {
          id: "1",
          name: "SaaS竞品",
          enname: "competingProducts",
        },
        {
          name: "PaaS竞品",
          id: "2",
          enname: "design",
        },
        {
          name: "找竞品",
          id: "3",
          enname: "research",
        },
        {
          name: "找研报",
          id: "4",
          enname: "case",
        },
        {
          name: "GPT in SaaS",
          id: "5",
          enname: "GPT—in—SaaS",
        },
        {
          name: "GPT in PaaS",
          id: "6",
          enname: "GPT—in—Paas",
        },
      ],
      saas,
      paas,
      jinpin,
      yanbao,
      GPT_in_saas,
      GPT_in_paas,
    };
  },
  methods: {
    change(index) {
      this.index = index;
    },

  },
  components: {
    UeTabs,
    ResourceCard,
    ResourceCardVideo,
  },
   mounted: {
    
  }
}
</script>

<style lang="scss" scoped>
.resource {
  > .resource-banner {
    position: relative;
    height: 132px;

    > img {
      width: 100%;
    }
  }

  > .resource-content {
    padding-top: 40px;

    .resource-enterprise {
      padding-top: 40px;

      > .title {
        display: flex;
        align-items: flex-end;
        text-align: left;
        margin: 0 0 40px 0;
        font-size: 18px;
        color: #333333;

        img {
          width: 19.5px;
          height: 19.5px;
          margin-right: 8px;
        }
      }
    }

    .resource-cards {
      width: 1180px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      > div {
        margin-bottom: 15px;
        margin-right: 15px;
      }
    }
  }
}
</style>